import type {MarketId} from './types';

// Disable products that are not available in the current market and sort them to the bottom
export function orderProductsByMarketAvailability(products: any[], marketId: MarketId): any[] {
    // @ts-ignore
    const enabledProducts = [];
    // @ts-ignore
    const disabledProducts = [];

    products.forEach((product) => {
        if (product.prices[marketId] && product.prices[marketId].isAvailable) {
            enabledProducts.push(product);
        } else {
            disabledProducts.push({...product, isDisabled: true});
        }
    });

    // @ts-ignore
    return enabledProducts.concat(disabledProducts);
}
